export default "__VITE_ASSET__TB9Pk6zF__"